module.exports = __webpack_public_path__ + "static/media/wish_VII_cs.4bc1bdd4.png";